module.exports = __webpack_public_path__ + "img/logo-sm-old.cd8d3fc0.png";